export default "__VITE_ASSET__CM$F1UBn__"